import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TypeText } from "../../ui-dto/text/type-text";
var HTML_TEMPLATE = "\n<div class=\"od-searchbox\" [ngStyle]=\"{'width': width}\">\n\t<div [class]=\"'od-searchbox-icon '+ _searchIconName\" [ngClass]=\"{'od-searchbox-icon-click':clickOnSearch}\" (click)=\"onSearch()\"></div>\n\t<input [(ngModel)]=\"_data\" [attr.type]=\"type\" [attr.placeholder]=\"placeholder == null ? null : placeholder \" (input)=\"onChange($event)\"\n\tclass=\"od-searchbox-input\"/>\n\t<div *ngIf=\"showCancelButton && _data != null && _data!=''\" (click)=\"onCancel($event)\" [class]=\"'od-searchbox-cancel '+ _cancelIconName\"></div>\n\t<div *ngIf=\"showDropDown\" (click)=\"onDropDownClick($event)\" [class]=\"'od-searchbox-dropdown '+ _dropdownIconName\"></div>\n</div>";
var CSS_STYLE = "\n.od-searchbox {\n\tborder: 1px solid #dfe2e9;\n    border-radius: 18px;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    padding-top: 4px;\n    padding-bottom: 4px;\n    padding-left: 11px;\n    padding-right: 11px;\n    background-color: #fff;\n    transition: all .15s linear;\n}\n\n.od-searchbox-icon{\n    display: flex;\n    width: 25px;\n    height: 26px;\n}\n\n.od-searchbox-icon-click{\n    cursor: pointer;\n}\n\n.od-searchbox-icon:before{\n    font-size: 16px;\n    color: #b7c1cd;\n    display: flex;\n    height: 100%;\n    line-height: 26px;\n}\n\n.od-searchbox-input {\n    outline: none;\n    display: flex;\n    border: 0 none;\n    font-size: 13px;\n    font-weight: bold;\n    font-family: sans-serif;\n    color: #555962;\n    width: calc(100% - 48px);\n    padding-left: 8px;\n    text-overflow: ellipsis;\n}\n\n.od-searchbox-cancel{\n\tdisplay: flex;\n    width: 40px;\n    height: 10px;\n    padding-left: 4px;\n    justify-content: center;\n    cursor:pointer;\n}\n\n.od-searchbox-cancel:before{\n    font-size: 10px;\n    color: #b7c1cd;\n}\n\n.od-searchbox-dropdown{\n    display: flex;\n    overflow: hidden;\n    width: 20px;\n    height: 10px;\n    margin-left: 7px;\n    justify-content: flex-end;\n    cursor: pointer;\n}\n\n.od-searchbox-dropdown:before{\n    font-size: 10px;\n    color: #b7c1cd;\n}\n";
var Searchbox = /** @class */ (function () {
    function Searchbox() {
        this.search = new EventEmitter();
        this.change = new EventEmitter();
        this.cancel = new EventEmitter();
        this.dropdownClick = new EventEmitter();
        this.data = null;
        this.placeholder = null;
        this.type = TypeText.SEARCH;
        this.searchIconName = "odi_search";
        this.cancelIconName = "odi_close";
        this.dropdownIconName = "odi_dropdown";
        this.showCancelButton = true;
        this.showDropDown = false;
    }
    Object.defineProperty(Searchbox.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (value) {
            this._data = (value == null) ? "" : value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchbox.prototype, "searchIconName", {
        set: function (value) {
            this._searchIconName = (value == null) ? "" : value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchbox.prototype, "cancelIconName", {
        set: function (value) {
            this._cancelIconName = (value == null) ? "" : value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Searchbox.prototype, "dropdownIconName", {
        set: function (value) {
            this._dropdownIconName = (value == null) ? "" : value;
        },
        enumerable: true,
        configurable: true
    });
    Searchbox.prototype.onSearch = function (ev) {
        this.search.emit(this._data);
    };
    Searchbox.prototype.onChange = function (ev) {
        this._data = ev.target.value;
        this.change.emit(this._data);
    };
    Searchbox.prototype.onCancel = function (ev) {
        this._data = ev.target.value;
        this.cancel.emit(ev);
    };
    Searchbox.prototype.onDropDownClick = function (ev) {
        this.dropdownClick.emit(ev);
    };
    Searchbox.decorators = [
        { type: Component, args: [{
                    selector: 'od-searchbox',
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    Searchbox.ctorParameters = function () { return []; };
    Searchbox.propDecorators = {
        "type": [{ type: Input },],
        "width": [{ type: Input },],
        "placeholder": [{ type: Input },],
        "showCancelButton": [{ type: Input },],
        "showDropDown": [{ type: Input },],
        "clickOnSearch": [{ type: Input },],
        "search": [{ type: Output },],
        "change": [{ type: Output },],
        "cancel": [{ type: Output },],
        "dropdownClick": [{ type: Output },],
        "data": [{ type: Input },],
        "searchIconName": [{ type: Input },],
        "cancelIconName": [{ type: Input },],
        "dropdownIconName": [{ type: Input },],
    };
    return Searchbox;
}());
export { Searchbox };
//# sourceMappingURL=searchbox.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-components/text/searchbox.js
// module id = 417
// module chunks = 14